<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span
        class="main-r_top_nav"
        :class="mainStatus === 'online' && 'active'"
        @click.stop="handleClick('online')"
      >在线文档</span>
      <!-- <span
        class="main-r_top_nav"
        :class="mainStatus === 'apiTest' && 'active'"
        @click.stop="handleClick('apiTest')"
      >测试工具</span> -->
    </div>
    <!-- 在线文档 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'online'">
      <online-doc :onlineData="onlineData"></online-doc>
    </div>
    <!-- 在线文档 END -->
    <!-- 测试工具 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'apiTest'">
      <api-test-doc :apiTestData="apiTestData"></api-test-doc>
    </div>
    <!-- 测试工具 END -->
  </div>
</template>

<script>
import onlineDoc from "../components/onlineDoc";

import apiTestDoc from "../components/apiTestDoc";

import {OPEN_API_TEST,OPEN_API_PRO} from '@/constants/index'

const apiUrlTest = 'logistics/trace';
export default {
  components: { onlineDoc , apiTestDoc },
  data() {
    return {
      mainStatus: "online",
      //当前请求URL
      apiBaseUrl: process.env.VUE_APP_API_URL + `/${apiUrlTest}`,

      onlineData: {
        //接口描述
        apiDesc: "通过单号查询快件的轨迹信息",
        //接口地址
        testApi: `${OPEN_API_TEST}/${apiUrlTest}`,
        proApi: `${OPEN_API_PRO}/${apiUrlTest}`,
        //参数描述  START
       postDataList:[

        //   请求头参数
            {
                title:'Headers',
                value:[
                    {name: "apiAccount",type: "Number",require: "Y",normal: "",describe: "接入方在平台的api账户标识",},
                    {name: "digest",type: "String",require: "Y",normal: "",describe: "签名字符串",},
                    {name: "timestamp",type: "Number",require: "Y",normal: "",describe: "时间戳，毫秒",},
                    ]
            },
             {
                title:'请求参数',
                 value:[
                    {name: "bizContent",type: "String",require: "Y",normal: "业务参数",describe: "业务参数模块内json格式的string类型",},
                ]
            },
            {
              title:"业务参数",
              value:[
                {name: "traceQueryInfo",type: "List[]",require: "Y",normal: "",describe: "业务参数"},
              ]
            },
           {
             title: "traceQueryInfo类型说明",
             value: [
               {name: "billCodes",type: "String",require: "Y",normal: "",describe: "运单号"},
               {name: "customerCode",type: "String",require: "Y",normal: "",describe: "客户编码"}
             ]
           }

        ],
        //参数描述  END
        //报文描述 start
        responseDataList:[

        //   响应参数
            {
                title:'响应参数',
                value:[
                    { name: "code",type: "String", require: "Y",normal: "",describe: "返回码，见附录",},
                    {name: "msg",type: "String",require: "Y",normal: "",describe: "描述",},
                    {name: "data",type: "Object",require: "Y",normal: "",describe: "业务数据",},
                  ]
            },
            {
              title:"data类型说明",
              value:[
                  {name: "billCode",type: "String",require: "Y",normal: "",describe: "运单号"},
                  {name: "details",type: "Array",require: "Y",normal: "",describe: "运单轨迹详情"}
                ]
            },
            {
              title:"details类型说明",
              value:[
                  {name: "scanTime",type: "String",require: "Y",normal: "",describe: "扫描时间"},
                  {name: "desc",type: "String",require: "Y",normal: "",describe: "轨迹描述"},
                  {name: "scanType",type: "String",require: "Y",normal: "",describe: `扫描类型 <p>1、快件揽收</p> <p>2、入仓扫描（停用）</p> <p>3、发件扫描</p> <p>4、到件扫描</p> <p>5、出仓扫描</p> <p>6、入库扫描</p> <p>7、代理点收入扫描</p> <p>8、快件取出扫描</p> <p>9、出库扫描</p> <p>10、快件签收</p> <p>11、问题件扫描</p> <p>12、安检扫描</p> <p>13、其他扫描</p> <p>14、退件扫描</p>`},
                  {name: "problemType",type: "String",require: "N",normal: "",describe: `<p>A1、客户取消寄件-网点</p> <p>A2、客户拒收</p> <p>A3、更改派送地址</p> <p>A4、退回件-网点</p><p>A7、异常件提醒</p> <p>A8、包裹异常-网点</p> <p>A9、收件人联系不上</p> <p>A10、收件人联系不上</p> <p>A11、多次派件失败</p> <p>A12、收件人信息错误</p> <p>A13、更改派送时间</p> <p>A14、客户拒收</p> <p>A15、收件地址不详</p> <p>A16、收件地址错误</p> <p>A17、包裹存放至网点</p> <p>A18、包裹存放至网点</p> <p>A19、收件地址禁止</p> <p>A20、包裹异常</p> <p>A21、包裹暂存网点</p> <p>A23、包裹延迟-节假日</p> <p>A24、包裹异常-中心</p> <p>A25、退回件-中心</p> <p>A26、客户取消寄件-中心</p><p>A27、异常天气</p><p>A28、自然灾害</p> <p>A29、代收/到付结算异议拒付</p> <p>A30、货未到齐</p> <p>A31、作废件</p> <p>A32、未录进仓编码</p> <p>A33、政府管制</p> <p>A34、乡镇件</p> <p>A35、发票问题客户拒收</p>`},
                  {name: "scanNetworkName",type: "String",require: "Y",normal: "",describe: "扫描网点名称"},
                  {name: "scanNetworkId",type: "String",require: "Y",normal: "",describe: "扫描网点ID"},
                  {name: "staffName",type: "String",require: "Y",normal: "",describe: "业务员姓名"},
                  {name: "staffContact",type: "String",require: "Y",normal: "",describe: "业务员联系方式"},
                  {name: "scanNetworkContact",type: "String",require: "Y",normal: "",describe: "扫描网点联系方式"},
                  {name: "scanNetworkProvince",type: "String",require: "Y",normal: "",describe: "扫描网点省份"},
                  {name: "scanNetworkCity",type: "String",require: "Y",normal: "",describe: "扫描网点城市"},
                  {name: "scanNetworkArea",type: "String",require: "Y",normal: "",describe: "扫描网点区/县"},
                  {name: "nextStopName",type: "String",require: "Y",normal: "",describe: "上一站(到件)或下一站名称(发件)"},
                  {name: "nextNetworkProvinceName",type: "String",require: "Y",normal: "",describe: "下一站省份（发件扫描类型时提供）"},
                  {name: "nextNetworkCityName",type: "String",require: "Y",normal: "",describe: "下一站城市（发件扫描类型时提供）"},
                  {name: "nextNetworkAreaName",type: "String",require: "Y",normal: "",describe: "下一站区/县（发件扫描类型时提供）"},
                  {name: "rebackStatus",type: "Number",require: "N",normal: "",describe: "退回件状态 0正常件 1退回件（10、快件签收时返回）"},
                  {name: "networkType",type: "String",require: "Y",normal: "",describe: "网点类型  中心/网点/集散/其他"},
                  {name: "signByOthersType",type: "String",require: "N",normal: "",describe: "代签收类型  驿站/快递柜 (6、入库扫描时返回)"},
                  {name: "signByOthersName",type: "String",require: "N",normal: "",describe: "代收名称 (6、入库扫描时返回)"},
                  {name: "signByOthersTel",type: "String",require: "N",normal: "",describe: "代收点电话 (6、入库扫描时返回)"},
                  {name: "pickCode",type: "String",require: "N",normal: "",describe: "取件码 (6、入库扫描时返回)"}
                ]
            }

        ],
        //请求示例
        requestCode: `Header：
    apiAccount=1627
    digest=U40e5sumorgd3YgZzU61Mw==
    timestamp=1565238848921

Body：
    bizContent = BizContent(
        traceQueryInfo=[
            TraceQueryInfo(billCode="UT0000717360450", customerCode="J0086474299"),
            TraceQueryInfo(billCode="UT0000714340641", customerCode="J0086474299"),
        ]
    )
    `,
        //返回示例
        responseCode: JSON.parse(`{
    "code": "1",
    "msg": "success",
    "data": [
        {
            "billCode": "UT0000352320970",
            "details": [
                {
                    "billCode": "UT0000352320970",
                    "scanTime": "2020-07-18 08:53:05",
                    "desc": "包裹已签收！签收人是【本人签收】，如有疑问请联系：13123456789，如需联系网点请拨打：17314954950 特  殊时期，极兔从不懈怠，感谢使用，我们时刻准备，再次为您服务！",
                    "scanType": "快件签收",
                    "problemType": null,
                    "scanNetworkTypeName": null,
                    "scanNetworkName": "南京玄武网点",
                    "scanNetworkId": 33,
                    "staffName": "test1042",
                    "staffContact": "13123456789",
                    "scanNetworkContact": null,
                    "scanNetworkProvince": "江苏省",
                    "scanNetworkCity": "南京市",
                    "scanNetworkArea": "玄武区",
                    "nextStopName": null,
                    "remark": null,
                    "nextNetworkProvinceName": null,
                    "nextNetworkCityName": null,
                    "nextNetworkAreaName": null
                },
                {
                    "billCode": "UT0000352320970",
                    "scanTime": "2020-07-18 08:52:53",
                    "desc": "快件离开【南京转运中心】已发往【南京玄武网点】，您的极兔包，离目的地更近一步啦！",
                    "scanType": "发件扫描",
                    "problemType": null,
                    "scanNetworkTypeName": null,
                    "scanNetworkName": "南京转运中心",
                    "scanNetworkId": 24,
                    "staffName": null,
                    "staffContact": null,
                    "scanNetworkContact": null,
                    "scanNetworkProvince": "江苏省",
                    "scanNetworkCity": "南京市",
                    "scanNetworkArea": "江宁区",
                    "nextStopName": "南京玄武网点",
                    "remark": null,
                    "nextNetworkProvinceName": null,
                    "nextNetworkCityName": null,
                    "nextNetworkAreaName": null
                },
                {
                    "billCode": "UT0000352320970",
                    "scanTime": "2020-07-18 08:52:51",
                    "desc": "快件到达【南京转运中心】，您的极兔包，离目的地更近一步啦！",
                    "scanType": "到件扫描",
                    "problemType": null,
                    "scanNetworkTypeName": null,
                    "scanNetworkName": "南京转运中心",
                    "scanNetworkId": 24,
                    "staffName": null,
                    "staffContact": null,
                    "scanNetworkContact": null,
                    "scanNetworkProvince": "江苏省",
                    "scanNetworkCity": "南京市",
                    "scanNetworkArea": "江宁区",
                    "nextStopName": "南京转运中心",
                    "remark": null,
                    "nextNetworkProvinceName": null,
                    "nextNetworkCityName": null,
                    "nextNetworkAreaName": null
                },
                {
                    "billCode": "UT0000352320970",
                    "scanTime": "2020-07-18 08:52:50",
                    "desc": "快件离开【南京雨花台春江新城网点】已发往【南京转运中心】，您的极兔包，离目的地更近一步啦！",
                    "scanType": "发件扫描",
                    "problemType": null,
                    "scanNetworkTypeName": null,
                    "scanNetworkName": "南京雨花台春江新城网点",
                    "scanNetworkId": 1772,
                    "staffName": null,
                    "staffContact": null,
                    "scanNetworkContact": null,
                    "scanNetworkProvince": "江苏省",
                    "scanNetworkCity": "南京市",
                    "scanNetworkArea": "江宁区",
                    "nextStopName": "南京转运中心",
                    "remark": null,
                    "nextNetworkProvinceName": null,
                    "nextNetworkCityName": null,
                    "nextNetworkAreaName": null
                },
                {
                    "billCode": "UT0000352320970",
                    "scanTime": "2020-07-18 08:52:48",
                    "desc": "包裹顺利到达【南京雨花台春江新城网点】15850664590，放心交给极兔小哥吧！",
                    "scanType": "入仓扫描",
                    "problemType": null,
                    "scanNetworkTypeName": null,
                    "scanNetworkName": "南京雨花台春江新城网点",
                    "scanNetworkId": 1772,
                    "staffName": null,
                    "staffContact": null,
                    "scanNetworkContact": null,
                    "scanNetworkProvince": "江苏省",
                    "scanNetworkCity": "南京市",
                    "scanNetworkArea": "江宁区",
                    "nextStopName": null,
                    "remark": null,
                    "nextNetworkProvinceName": null,
                    "nextNetworkCityName": null,
                    "nextNetworkAreaName": null
                },
                {
                    "billCode": "UT0000352320970",
                    "scanTime": "2020-07-18 08:52:43",
                    "desc": "【南京雨花台春江新城网点】您的极兔小哥test1040(13123456789)已取件。如需联系网点，请拨打   15850664590 特殊时期，您的牵挂，让极兔小哥为您速递！ᕱ⑅ᕱ",
                    "scanType": "快件揽收",
                    "problemType": null,
                    "scanNetworkTypeName": null,
                    "scanNetworkName": "南京雨花台春江新城网点",
                    "scanNetworkId": 1772,
                    "staffName": "test1040",
                    "staffContact": "13123456789",
                    "scanNetworkContact": null,
                    "scanNetworkProvince": "江苏省",
                    "scanNetworkCity": "南京市",
                    "scanNetworkArea": "江宁区",
                    "nextStopName": null,
                    "remark": null,
                    "nextNetworkProvinceName": null,
                    "nextNetworkCityName": null,
                    "nextNetworkAreaName": null
                }
            ]
        },
        {
            "billCode": "UT0000359748995",
            "details": [
                {
                    "billCode": "UT0000359748995",
                    "scanTime": "2020-07-18 08:53:05",
                    "desc": "包裹已签收！签收人是【本人签收】，如有疑问请联系：13123456789，如需联系网点请拨打：17314954950 特  殊时期，极兔从不懈怠，感谢使用，我们时刻准备，再次为您服务！",
                    "scanType": "快件签收",
                    "problemType": null,
                    "scanNetworkTypeName": null,
                    "scanNetworkName": "南京玄武网点",
                    "scanNetworkId": 33,
                    "staffName": "test1042",
                    "staffContact": "13123456789",
                    "scanNetworkContact": null,
                    "scanNetworkProvince": "江苏省",
                    "scanNetworkCity": "南京市",
                    "scanNetworkArea": "玄武区",
                    "nextStopName": null,
                    "remark": null,
                    "nextNetworkProvinceName": null,
                    "nextNetworkCityName": null,
                    "nextNetworkAreaName": null
                },
                {
                    "billCode": "UT0000359748995",
                    "scanTime": "2020-07-18 08:52:53",
                    "desc": "快件离开【南京转运中心】已发往【南京玄武网点】，您的极兔包，离目的地更近一步啦！",
                    "scanType": "发件扫描",
                    "problemType": null,
                    "scanNetworkTypeName": null,
                    "scanNetworkName": "南京转运中心",
                    "scanNetworkId": 24,
                    "staffName": null,
                    "staffContact": null,
                    "scanNetworkContact": null,
                    "scanNetworkProvince": "江苏省",
                    "scanNetworkCity": "南京市",
                    "scanNetworkArea": "江宁区",
                    "nextStopName": "南京玄武网点",
                    "remark": null,
                    "nextNetworkProvinceName": null,
                    "nextNetworkCityName": null,
                    "nextNetworkAreaName": null
                },
                {
                    "billCode": "UT0000359748995",
                    "scanTime": "2020-07-18 08:52:51",
                    "desc": "快件到达【南京转运中心】，您的极兔包，离目的地更近一步啦！",
                    "scanType": "到件扫描",
                    "problemType": null,
                    "scanNetworkTypeName": null,
                    "scanNetworkName": "南京转运中心",
                    "scanNetworkId": 24,
                    "staffName": null,
                    "staffContact": null,
                    "scanNetworkContact": null,
                    "scanNetworkProvince": "江苏省",
                    "scanNetworkCity": "南京市",
                    "scanNetworkArea": "江宁区",
                    "nextStopName": "南京转运中心",
                    "remark": null,
                    "nextNetworkProvinceName": null,
                    "nextNetworkCityName": null,
                    "nextNetworkAreaName": null
                },
                {
                    "billCode": "UT0000359748995",
                    "scanTime": "2020-07-18 08:52:50",
                    "desc": "快件离开【南京雨花台春江新城网点】已发往【南京转运中心】，您的极兔包，离目的地更近一步啦！",
                    "scanType": "发件扫描",
                    "problemType": null,
                    "scanNetworkTypeName": null,
                    "scanNetworkName": "南京雨花台春江新城网点",
                    "scanNetworkId": 1772,
                    "staffName": null,
                    "staffContact": null,
                    "scanNetworkContact": null,
                    "scanNetworkProvince": "江苏省",
                    "scanNetworkCity": "南京市",
                    "scanNetworkArea": "江宁区",
                    "nextStopName": "南京转运中心",
                    "remark": null,
                    "nextNetworkProvinceName": null,
                    "nextNetworkCityName": null,
                    "nextNetworkAreaName": null
                },
                {
                    "billCode": "UT0000359748995",
                    "scanTime": "2020-07-18 08:52:48",
                    "desc": "包裹顺利到达【南京雨花台春江新城网点】15850664590，放心交给极兔小哥吧！",
                    "scanType": "入仓扫描",
                    "problemType": null,
                    "scanNetworkTypeName": null,
                    "scanNetworkName": "南京雨花台春江新城网点",
                    "scanNetworkId": 1772,
                    "staffName": null,
                    "staffContact": null,
                    "scanNetworkContact": null,
                    "scanNetworkProvince": "江苏省",
                    "scanNetworkCity": "南京市",
                    "scanNetworkArea": "江宁区",
                    "nextStopName": null,
                    "remark": null,
                    "nextNetworkProvinceName": null,
                    "nextNetworkCityName": null,
                    "nextNetworkAreaName": null
                },
                {
                    "billCode": "UT0000359748995",
                    "scanTime": "2020-07-18 08:52:43",
                    "desc": "【南京雨花台春江新城网点】您的极兔小哥test1040(13123456789)已取件。如需联系网点，请拨打   15850664590 特殊时期，您的牵挂，让极兔小哥为您速递！ᕱ⑅ᕱ",
                    "scanType": "快件揽收",
                    "problemType": null,
                    "scanNetworkTypeName": null,
                    "scanNetworkName": "南京雨花台春江新城网点",
                    "scanNetworkId": 1772,
                    "staffName": "test1040",
                    "staffContact": "13123456789",
                    "scanNetworkContact": null,
                    "scanNetworkProvince": "江苏省",
                    "scanNetworkCity": "南京市",
                    "scanNetworkArea": "江宁区",
                    "nextStopName": null,
                    "remark": null,
                    "nextNetworkProvinceName": null,
                    "nextNetworkCityName": null,
                    "nextNetworkAreaName": null
                }
            ]
        },
        {
            "billCode": "UT0000353613157 ",
            "details": [
                {
                    "billCode": "UT0000353613157 ",
                    "scanTime": "2020-07-18 08:53:05",
                    "desc": "包裹已签收！签收人是【本人签收】，如有疑问请联系：13123456789，如需联系网点请拨打：17314954950 特  殊时期，极兔从不懈怠，感谢使用，我们时刻准备，再次为您服务！",
                    "scanType": "快件签收",
                    "problemType": null,
                    "scanNetworkTypeName": null,
                    "scanNetworkName": "南京玄武网点",
                    "scanNetworkId": 33,
                    "staffName": "test1042",
                    "staffContact": "13123456789",
                    "scanNetworkContact": null,
                    "scanNetworkProvince": "江苏省",
                    "scanNetworkCity": "南京市",
                    "scanNetworkArea": "玄武区",
                    "nextStopName": null,
                    "remark": null,
                    "nextNetworkProvinceName": null,
                    "nextNetworkCityName": null,
                    "nextNetworkAreaName": null
                },
                {
                    "billCode": "UT0000353613157 ",
                    "scanTime": "2020-07-18 08:52:53",
                    "desc": "快件离开【南京转运中心】已发往【南京玄武网点】，您的极兔包，离目的地更近一步啦！",
                    "scanType": "发件扫描",
                    "problemType": null,
                    "scanNetworkTypeName": null,
                    "scanNetworkName": "南京转运中心",
                    "scanNetworkId": 24,
                    "staffName": null,
                    "staffContact": null,
                    "scanNetworkContact": null,
                    "scanNetworkProvince": "江苏省",
                    "scanNetworkCity": "南京市",
                    "scanNetworkArea": "江宁区",
                    "nextStopName": "南京玄武网点",
                    "remark": null,
                    "nextNetworkProvinceName": null,
                    "nextNetworkCityName": null,
                    "nextNetworkAreaName": null
                },
                {
                    "billCode": "UT0000353613157 ",
                    "scanTime": "2020-07-18 08:52:51",
                    "desc": "快件到达【南京转运中心】，您的极兔包，离目的地更近一步啦！",
                    "scanType": "到件扫描",
                    "problemType": null,
                    "scanNetworkTypeName": null,
                    "scanNetworkName": "南京转运中心",
                    "scanNetworkId": 24,
                    "staffName": null,
                    "staffContact": null,
                    "scanNetworkContact": null,
                    "scanNetworkProvince": "江苏省",
                    "scanNetworkCity": "南京市",
                    "scanNetworkArea": "江宁区",
                    "nextStopName": "南京转运中心",
                    "remark": null,
                    "nextNetworkProvinceName": null,
                    "nextNetworkCityName": null,
                    "nextNetworkAreaName": null
                },
                {
                    "billCode": "UT0000353613157 ",
                    "scanTime": "2020-07-18 08:52:50",
                    "desc": "快件离开【南京雨花台春江新城网点】已发往【南京转运中心】，您的极兔包，离目的地更近一步啦！",
                    "scanType": "发件扫描",
                    "problemType": null,
                    "scanNetworkTypeName": null,
                    "scanNetworkName": "南京雨花台春江新城网点",
                    "scanNetworkId": 1772,
                    "staffName": null,
                    "staffContact": null,
                    "scanNetworkContact": null,
                    "scanNetworkProvince": "江苏省",
                    "scanNetworkCity": "南京市",
                    "scanNetworkArea": "江宁区",
                    "nextStopName": "南京转运中心",
                    "remark": null,
                    "nextNetworkProvinceName": null,
                    "nextNetworkCityName": null,
                    "nextNetworkAreaName": null
                },
                {
                    "billCode": "UT0000353613157 ",
                    "scanTime": "2020-07-18 08:52:48",
                    "desc": "包裹顺利到达【南京雨花台春江新城网点】15850664590，放心交给极兔小哥吧！",
                    "scanType": "入仓扫描",
                    "problemType": null,
                    "scanNetworkTypeName": null,
                    "scanNetworkName": "南京雨花台春江新城网点",
                    "scanNetworkId": 1772,
                    "staffName": null,
                    "staffContact": null,
                    "scanNetworkContact": null,
                    "scanNetworkProvince": "江苏省",
                    "scanNetworkCity": "南京市",
                    "scanNetworkArea": "江宁区",
                    "nextStopName": null,
                    "remark": null,
                    "nextNetworkProvinceName": null,
                    "nextNetworkCityName": null,
                    "nextNetworkAreaName": null
                },
                {
                    "billCode": "UT0000353613157 ",
                    "scanTime": "2020-07-18 08:52:43",
                    "desc": "【南京雨花台春江新城网点】您的极兔小哥test1040(13123456789)已取件。如需联系网点，请拨打   15850664590 特殊时期，您的牵挂，让极兔小哥为您速递！ᕱ⑅ᕱ",
                    "scanType": "快件揽收",
                    "problemType": null,
                    "scanNetworkTypeName": null,
                    "scanNetworkName": "南京雨花台春江新城网点",
                    "scanNetworkId": 1772,
                    "staffName": "test1040",
                    "staffContact": "13123456789",
                    "scanNetworkContact": null,
                    "scanNetworkProvince": "江苏省",
                    "scanNetworkCity": "南京市",
                    "scanNetworkArea": "江宁区",
                    "nextStopName": null,
                    "remark": null,
                    "nextNetworkProvinceName": null,
                    "nextNetworkCityName": null,
                    "nextNetworkAreaName": null
                }
            ]
        }
    ]
}`),

        //错误代码提示
        errcodeJson: [{code:'145003100',msg:"运单号非法"},
          {code:'145003502',msg:"运单号个数超过30"}]
      },

      apiTestData: {
          _headerData: {
            apiAccount: "1001",
            digest: "U40e5sumorgd3YgZzU61Mw==",
            timestamp: "1565238848921",
          },
          data:{
             bizContent: `{"billCodes":"UT0000352320970,UT0000359748995,UT0000353613157"}`,
          },
        //必须要验证的参数
        requestData:['apiAccount','digest','timestamp','bizContent'],
        textareaData:{
          bizContent:true
        },
        //促发接口
        apiUrl: `/mock/${apiUrlTest}`,
        //返回
        ResponseJson: "",
        //当前请求URL
        apiBaseUrl: process.env.VUE_APP_API_URL + `/mock/${apiUrlTest}`,
        //错误代码提示
        errcodeJson: [
          {code:'145003100',msg:"运单号非法"},
          {code:'145003502',msg:"运单号个数超过30"}]
      },
    };
  },
  created() {},
  methods: {
    handleClick(status) {
      this.mainStatus = status;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/apiTest.scss";
</style>
